
import { Card } from "@/components/ui/card";
import { regions } from "@/types/regions";
import { useTranslation } from "@/hooks/useTranslation";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function Regions() {
  const { t } = useTranslation();

  return (
    <div className="container py-8">
      <h1 className="text-3xl font-bold mb-6">{t('regions')}</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {regions.map((region, index) => (
          <motion.div
            key={region.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
          >
            <Link to={`/regions/${region.id}`}>
              <Card className="p-6 hover:bg-accent transition-colors">
                <h2 className="text-xl font-semibold mb-2">{region.name}</h2>
                <p className="text-muted-foreground">{region.description}</p>
              </Card>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
